import React from "react";
import DatePicker from 'sassy-datepicker';
import 'sassy-datepicker/dist/styles.css';

const Calendar = (props) => {
  const {selectedDate, setSelectedDate} = props;
  const today = new Date();

  return (
    <DatePicker
      value={selectedDate}
      onChange={setSelectedDate}
      minDate={today}
      weekStartsFrom="Monday"
      className="absolute"
    />
  )
}

export default Calendar;
